import Vue from 'vue'
import Router from 'vue-router';
const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error => error)
}
const routes = [
  {
    path: '/',
    name: 'Home',
    component: resolve => require(["@/view/Home"], resolve),
  },
  {
    path: '/proposition',
    name: 'Proposition',
    component: resolve => require(["@/view/Proposition"], resolve),
  },
  {
    path: '/product',
    name: 'Product',
    component: resolve => require(["@/view/Product"], resolve),
  },

];
Vue.use(Router)
const router = new Router({
  mode: 'history',
  fallback: false,
  // base: '/',
  scrollBehavior: () => ({ y: 0 }),
  routes
});

router.beforeEach((to, from, next) => {
  if (to.matched.length === 0) {  //如果未匹配到路由
    next('/')
  } else {
    // document.title = to.meta.title;
    next()
  }

})
export default router;